import API from '../api/index';
import IUser from '../types/User';
import IResetPass from '../types/ResetPass';
import { SignUpForm } from '../components/auth/SignUp';
import IEntidadFacturacion, { CasoCambioTitular, ICambioTitularOpciones, IDatosFacturacion } from '../types/EntidadFacturacion';

const getUser = (_id: string) => API.get(`/user${_id}`);
const signIn = (data: IUser) => API.post('/signin', data);
const signUp = (data: SignUpForm) => API.post('/signup', data);
const reSendEmail = (_id: string) => API.post(`resend${_id}`);
const editEmail = (_id: string, data: any) => API.patch(`/useremail${_id}`, data);
const resetPass = (email: string) => API.get(`/resetpass${email}`);
const changePass = (_id: string, data: IResetPass) => API.patch(`changepass${_id}`, data);
const updateUser = (_id: string, data: any) => API.patch(`/user${_id}`, data);

const saveClinicData = (_id: string, data: any) => API.patch(`/clinicData${_id}`, data);
const saveDatosFacturacion = (_id: string, data: any) => API.patch(`/clinicFacturacion${_id}`, data);
const createClienteStripe = (_id: string, data: any) => API.patch(`/clienteStripe${_id}`, data);
const createSuscripcionStripe = (_id: string, data: any) => API.patch(`/suscripcionStripe${_id}`, data);
const updatePaymentMethod = (_id: string, data: any) => API.patch(`/updatePaymentMethod${_id}`, data);

const createPass = (email: string) => API.get(`/createpass${email}`);
const createPassEmpleado = (_id: string, data: IResetPass) => API.patch(`empleadocreatepass${_id}`, data);

const getBillingData = (_id: string) => API.get(`/billing${_id}`);
const updateSecurePaymentMethod = (_id: string, data: any) => API.patch(`/updateSecurePaymentMethod${_id}`, data);
// Datos fiscales de la principal (= los de la suscripción). Un NIF nuevo es un cambio de titular: ver CambioTitularDialog.
const updateBillingData = (_id: string, data: IDatosFacturacion & ICambioTitularOpciones) =>
    API.patch<{ billingData: IDatosFacturacion, datosFacturacionAdicional: IEntidadFacturacion[], caso: CasoCambioTitular }>(`/updateBillingData${_id}`, data);

const saveClinicStyle = (_id: string, data: any) => API.patch(`/clinicStyle${_id}`, data);

const AuthService = {
    getUser,
    signIn,
    signUp,
    reSendEmail,
    editEmail,
    resetPass,
    changePass,
    updateUser,
    saveClinicData,
    saveDatosFacturacion,
    createClienteStripe,
    createSuscripcionStripe,
    createPass,
    createPassEmpleado,
    getBillingData,
    updatePaymentMethod,
    updateSecurePaymentMethod,
    updateBillingData,
    saveClinicStyle
};

export default AuthService;